import "./RecipeDetail.css"

import React from "react";
import { useParams } from "react-router-dom";
import { Globalalert, Navbar, Footer, Contact, ReturnToRecipes } from '../../components'

import recipesList from '../../data/recipesList';

import {
    FaPrint,
    FaDownload
} from 'react-icons/fa';

const difficultyDefinitions = {
    Wolf: "Any potential recipe that poses a difficulty to an unknown degree.",
    Tiger: "A difficult recipe for an average home cook.",
    Demon: "A difficult recipe for a professional chef.",
    Dragon: "A difficult recipe requiring many unique ingredients not readily available in local grocery stores.",
    God: "A recipe so difficult, it might just destroy your dinner plans — or at least your kitchen..",
};

function RecipeDetail() {
    const { recipeId } = useParams();
    console.log("recipeId:", recipeId);
    const recipe = recipesList[recipeId];

    if (!recipe) {
        return (
            <div id="no-recipe-page" className="site">
                <Navbar primaryColor="#000000" />
                <section className="error-section">
                    <div className="error-container">
                        <h1 className="error-title">Oops! Looks like this Recipe is Missing</h1>
                        <p className="error-message">Maybe it’s not quite ready yet, or I just made a typo. Either way, don't worry – there are plenty of other tasty recipes to discover back in my recipes catalog.</p>
                        <div className="btn-primary-container">
                            <a href="/recipes" className="btn-primary">View All Recipes</a>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    const { youtubeID, videoCaption, title, date, duration, difficulty, ingredients, steps } = recipe;

    const handlePrint = () => {
        window.print();
    };

    return (
        <div id="recipe-page" className="site">
            <Navbar primaryColor="#000000" />

            <ReturnToRecipes className="return-to-recipes"/>

            <section className="recipe-section">
                <header className="recipe-header-container">
                    <div className="recipe-header-title-container">
                        <h1 className="recipe-header-title">{title}</h1>
                        <FaPrint className="fa-icon" onClick={handlePrint}/>
                    </div>
                    <p className="recipe-header-subheader">
                        {date} | {duration} |{" "}
                        <span className="tooltip">
                            {difficulty}
                            <span className="tooltip-text">
                                Disaster Level ({difficulty}): {difficultyDefinitions[difficulty]}
                            </span>
                        </span>
                    </p>
                </header>

                <div className="video-container">
                    <iframe
                        className="youtube-video-web"
                        src={`https://www.youtube.com/embed/${youtubeID}`}
                        title={title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                    <div className='youtube-video-print'>
                        <img className="youtube-video-thumbnail" src={`https://img.youtube.com/vi/${youtubeID}/maxresdefault.jpg`} alt="YouTube thumbnail"/>
                    </div>
                </div>
                <figcaption className="youtube-video-caption">{videoCaption}</figcaption>

                <div className="recipe-content-container">
                    <div className="recipe-ingredients-column">
                        <h1 className="recipe-ingredients-title">Ingredients:</h1>

                        {Object.keys(ingredients).map((section) => (
                            <ul className="recipe-ingredient-list" key={section}>
                                <h2 className="recipe-item-header">{section}:</h2>
                                {ingredients[section].map((item, index) => (
                                    <li className="recipe-item-ingredient" key={index}>{item}</li>
                                ))}
                            </ul>
                        ))}
                    </div>
                    <div className="recipe-instructions-column">
                        <h1 className="recipe-instructions-title">Preparations</h1>
                        {Object.keys(steps).map((section) => (
                            <ol className="recipe-instructions-list" key={section}>
                                <h2 className="recipe-item-header">{section}:</h2>
                                {steps[section].map((step, index) => (
                                    <li className="recipe-item-instructions" key={index}>{index + 1}.) {step}</li>
                                ))}
                            </ol>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}

export default RecipeDetail;